import CoachingClarity from "./CoachingClarity";
import CoachingImpact from "./CoachingImpact";
import CoachingInclusion from "./CoachingInclusion";
import type { CoachingSectionProps } from "./types";

const ScrollableCoachingContent = (props: CoachingSectionProps) => {
  return (
    <>
      <CoachingClarity {...props} />
      <CoachingInclusion {...props} />
      <CoachingImpact {...props} />
    </>
  );
};

export default ScrollableCoachingContent;
